export default __webpack_public_path__ + "static/media/MILKVITABANGLADESH.4014b599.jpg";